import { twoLetterCountryCodeKey } from '../../constants/countryProperties';
import {
  contextKeysFor3DSAuth,
  STRIPE_SETUP_MODE,
} from '../../constants/stripePayment.constant';
import { stripePaymentTypes } from '../components/paymentMethodStripe/paymentTypes.constant';

const getPayloadBasedOnType = (payloadOnTypeList) => {
  const { last4, type, exp_month, exp_year, brand } = payloadOnTypeList;
  if (type === stripePaymentTypes.CARD) {
    const expirationDate = `${exp_month}/${exp_year.toString().slice(-2)}`;
    return {
      stripeAccountPayload: {
        // CardAccountNumberMasked: `************${last4}`,
        CardAccountNumberMasked: `*****${last4}`,
        CardExpirationDate: expirationDate,
        PaymentMethodSubType: brand,
      },
      name: `${brand} ending in ${last4}`,
    };
  }
  return {
    stripeAccountPayload: {},
    name: `stripe ${type}`,
  };
};

const paymentInstrumentPayload = (payloadList) => {
  const { id, type } = payloadList;
  const paymentMethodPayload = getPayloadBasedOnType(payloadList);

  return {
    StripeAccount: {
      PaymentMethodId: id,
      PaymentMethodType: `${type}`,
      ...paymentMethodPayload.stripeAccountPayload,
    },
    Name: paymentMethodPayload.name,
    Type: '22',
    Default: true,
  };
};

export const threeDSDetailPayload = {
  ThreeDSDetail: {
    ThreeDSRedirectUriReference: ASCENDON_ENV_CONFIG.stripe.returnUrl,
  },
};

export const paymentOrderFaultForHandle3DSActivity = (faultEntity) => {
  const { merchantData, paymentReferenceId } = contextKeysFor3DSAuth;
  const stripeClientSecret = faultEntity?.Fault?.ContextData?.find(
    (context) => {
      if (context.Key === merchantData) {
        return context.Value;
      }
      return null;
    },
  )?.Value;

  const stripePaymentId = faultEntity?.Fault?.ContextData?.find((context) => {
    if (context.Key === paymentReferenceId) {
      return context.Value;
    }
    return null;
  })?.Value;

  return { stripeClientSecret, stripePaymentId };
};

export const orderPayloadActivity = (
  submitOrderPayloadList,
  isCheckout,
  isStripePaymentInstrumentEnabled,
) => {
  const {
    shoppingCartList,
    stripeResponse,
    getAdditionalProperties,
    redemptionCodesPayload,
  } = submitOrderPayloadList;

  const RedemptionCodes = redemptionCodesPayload?.length
    ? redemptionCodesPayload
    : undefined;
  if (isCheckout && !isStripePaymentInstrumentEnabled) {
    const { ShoppingCart } = shoppingCartList;
    const submitOrderPayload = {
      ShoppingCart: ShoppingCart,
      PaymentInstruments: [{ ...paymentInstrumentPayload(stripeResponse) }],
      AdditionalProperties: getAdditionalProperties,
      RedemptionCodes,
      ...threeDSDetailPayload,
    };
    return submitOrderPayload;
  }
  if (isStripePaymentInstrumentEnabled) {
    return {
      PaymentInstruments: [{ ...paymentInstrumentPayload(stripeResponse) }],
      AdditionalProperties: getAdditionalProperties,
      RedemptionCodes,
      ...threeDSDetailPayload,
    };
  }
  return {
    PaymentInstruments: [
      {
        ...paymentInstrumentPayload(stripeResponse),
      },
    ],
    RedemptionCodes,
    ...threeDSDetailPayload,
  };
};

export const getDefaultBillingAddressForUpdateSubscription = (
  paymentMethodItem,
  selectedTwoLetterCountry,
) => {
  const { BillingAddress, NameOnCard } = paymentMethodItem || {};
  if (!Object.keys(BillingAddress || {}).length) {
    return {
      name: '',
      address: {
        line1: '',
        line2: '',
        country: selectedTwoLetterCountry,
        city: '',
        state: '',
        postal_code: '',
      },
    };
  }

  const {
    LineOne: line1,
    LineTwo: line2,
    City: city,
    State: state,
    PostalCode: postal_code,
  } = BillingAddress;
  const billAddressDefaultValues = {
    name: NameOnCard,
    address: {
      line1,
      line2: line2 || '',
      country: selectedTwoLetterCountry,
      city,
      state,
      postal_code,
    },
  };
  return billAddressDefaultValues;
};

export const getPayloadWithoutBillingAddress = (payload) => {
  const { BillingAddress, ...submitOrderPayload } = payload;
  return {
    stripeFormBillingAddress: BillingAddress,
    payloadWithoutBillingAddress: submitOrderPayload,
  };
};

export const getMatchedBillingAddress = ({
  paymentInstrumentPayload,
  newBillingAddress,
  addressList,
}) => {
  let paymentInstrument;
  if (paymentInstrumentPayload) {
    [paymentInstrument] = paymentInstrumentPayload;
  }
  const BillingAddress = paymentInstrument?.BillingAddress || newBillingAddress;
  const { City, LineOne, LineTwo, Country, State, PostalCode } =
    BillingAddress || {};
  const findBillingAddress = (addressList || []).find((item) => {
    const noState = !item.State && !State;
    const stateMatches = noState || item.State === State;
    const isBillingAddressAvailable =
      item.City === City &&
      item.LineOne === LineOne &&
      item.Country === Country &&
      stateMatches &&
      item.PostalCode === PostalCode.split(' ').join('');
    if (!LineTwo) {
      return isBillingAddressAvailable;
    }
    return item?.LineTwo === LineTwo && isBillingAddressAvailable;
  });
  return findBillingAddress;
};

export const getStripePaymentType = (stripePaymentMethodResponse) => {
  const getCard =
    stripePaymentMethodResponse?.card?.wallet?.type ||
    stripePaymentMethodResponse?.type;
  return getCard;
};

export const isStripeWallet = (stripePaymentType) =>
  stripePaymentType === stripePaymentTypes.GOOGLE_PAY ||
  stripePaymentType === stripePaymentTypes.APPLE_PAY;
//stripePaymentType === stripePaymentTypes.PAYPAL;

const getCountryValueBasedOnTwoLetterCountryCode = (
  countryCodeList,
  selectedTwoLetterCountry,
) => {
  const findTwoLetterCountryCode = countryCodeList.find((countryCode) =>
    countryCode?.AdditionalProperties?.find(
      (item) =>
        item.Key === twoLetterCountryCodeKey &&
        item.Value === selectedTwoLetterCountry,
    ),
  );

  if (!findTwoLetterCountryCode) {
    return selectedTwoLetterCountry;
  }

  return findTwoLetterCountryCode?.Value;
};

export const paymentMethodBillingAddress = (
  isWallet,
  address,
  name,
  metadataCountryCodeList,
  selectedCountryValue,
  subscriberUserName,
  translatedStateAndCity,
) => {
  const { translatedState, translatedCity } = translatedStateAndCity;
  const commonBillingDetails = {
    LineOne: address.line1,
    LineTwo: address.line2,
    City: address.city,
    State: address.state,
    PostalCode: address.postal_code,
    DefaultBilling: true,
  };

  if (isWallet) {
    const selectedThreeLetterCountry =
      getCountryValueBasedOnTwoLetterCountryCode(
        metadataCountryCodeList,
        address.country,
      );
    return {
      BillingAddress: {
        ...commonBillingDetails,
        Name: name || subscriberUserName,
        Country: selectedThreeLetterCountry,
        City: translatedCity || address.city,
        State: translatedState || address.state,
      },
    };
  }
  return {
    BillingAddress: {
      ...commonBillingDetails,
      Name: name,
      Country: selectedCountryValue || address.country,
      City: translatedCity || address.city,
      State: translatedState || address.state,
    },
  };
};

export const getPriceForStripe = (input, currencyCode) => {
  const zeroDecimalCurrencies = [
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
  ];
  const threeDecimalCurrencies = ['BHD', 'JOD', 'KWD', 'OMR', 'TND'];
  if (zeroDecimalCurrencies.indexOf(currencyCode?.toUpperCase()) > -1) {
    return input;
  } else if (threeDecimalCurrencies.indexOf(currencyCode?.toUpperCase()) > -1) {
    return Math.round(input * 1000);
  } else {
    return Math.round(input * 100);
  }
};

export const setElementsOptions = (amount, mode, currencyCode) => {
  const isAmountGreaterthanZero = amount && amount > 0;
  if (isAmountGreaterthanZero) {
    return {
      mode,
      amount: getPriceForStripe(amount, currencyCode),
    };
  }
  return {
    mode: STRIPE_SETUP_MODE,
  };
};

export const getPaymentTypesFromStripeList = (getPaymentTypes) =>
  getPaymentTypes.reduce(
    (all, item) => {
      if (item === stripePaymentTypes.APPLE_PAY) {
        all.applePay = true;
      }
      if (item === stripePaymentTypes.GOOGLE_PAY) {
        all.googlePay = true;
      }
      if (item === stripePaymentTypes.PAYPAL) {
        all.paypal = true;
      }
      return all;
    },
    { applePay: false, googlePay: false, paypal: false },
  );
